import { ThreeFriendsIcon } from "../../icons/ThreeFriendsIcon"
import { Label } from "../Label"
import { StarAnim } from "../StarAnim"
import styles from './styles.module.scss'

type Props = {
    label: string
}

export const Condition2Art = ({ label }: Props) => {
    return <div className={styles.container}>
        <div className={styles.iconWrap}>
            <ThreeFriendsIcon />
        </div>
        <Label label={label} />
        <div className={styles.starAnimWrap}>
            <StarAnim width={140} height={140} className={styles.starAnim} />
        </div>
    </div>
}